import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex } from 'antd';
import { MSkeleton } from '@Components/Base';
import { FormikHelpers, useFormik } from 'formik';

import {
  useAppDispatch,
  useAppSelector,
  useIsLoadedConent,
  useNavigationToListRequests,
} from '@Hooks/index';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';
import {
  currentMaterialManagest,
  currentMaterialRequest,
  materialCostCenters,
  materialStoreOverhead,
  materialRequestCreateRequisitionInfo,
  modalManager,
  modalManagerItem,
  mrSearchManagerSelector,
  mrSelectAllManagerSelector,
} from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';
import {
  useDeleteRequisitionDocumentMutation,
  useDeleteRequisitionItemFormMutation,
  useGetRequisitionCodeDescItemsMutation,
  useGetRequisitionDocumentsMutation,
  useGetRequisitionItemsMutation,
  useGetStoreOverheadMutation,
  usePostRequisitionDocumentMutation,
  usePostRequisitionFormMutation,
  usePostRequisitionItemFormMutation,
} from '@Features/MaterialRequest/requests/MaterialRequisition/store/api/MaterialRequestApiSlice';

import { useGetCostCenterMutation } from '@Store/api/dictionaryApiSlice';
import { RequestListSearchResponse } from '@Types/api/requestList';
import {
  DocumentFormUploadResponse,
  MaterialRequisitionDocumentRequest,
  MaterialRequisitionDocumentResponse,
  MaterialRequisitionFormRequest,
  MaterialRequisitionItemFormRequest,
  MaterialRequisitionItemFormResponse,
} from '@Types/api/form';
import FormItems from '@Components/MainForm/components/FormItems/FormItems';
import { MainForm, RequiredNotification } from '@Components/index';
import { FooterActions } from '@Enum/index';
import {
  getCompaniesDictSelector,
  getCostCenterTypeDict,
  getCurrencies,
  getMrForDict,
  getWarrantyTypeDict,
} from '@Store/selectors/dictionarySelector';
import {
  transformCompaniesDictToOptions,
  transformCostCenterDictToOptions,
  transformCurrenciesToOptions,
  transformDictToOptions,
  transformStoreOverheadToOption,
} from '@Utils/transformToOptions';
import { isNotNullValues } from '@Utils/isNotNullValues';
import { NotificationContext } from '@Context/NotificationContext';
import { fileUploadActions } from '@Store/slices/fileUploadSlice';

import { currentFileUploadSelector } from '@Store/selectors/fileUploadSelector';
import { useFormUploadMutation } from '@Store/api/dmsApiSlice';
import MRFeatureRoutePath from '@Features/router/mr/MRFeatureRoutePath.enum';
import { FileUpload } from '@Types/index';
import { CostCenter } from '@Types/api/common/dictionary';
import { initialValuesForm } from '../initialValues';
import { MaterialRequestFormValues } from '../type';
import MaterialFormChanger from '../components/MaterialFormChanger';
import MaterialsSection from '../components/MaterialsSection/MaterialsSection';
import RequestHeaderSection from '../components/RequestHeaderSection/RequestHeaderSection';
import { materialRequestActions } from '../../store/materialRequestSlice';

import DocumentsSection from '../components/DocumentsSection/DocumentsSection';

import MaterialActions from '../components/Base/MaterialActions/MaterialActions';
import { StepType } from '../StepType.enum';

import {
  findCompanyType,
  findCostCenter,
  findCostCenterType,
  findDocumentItemBySearchValue,
  findMaterialItemBySearchValue,
  findMrForType,
} from '../../../utils/finder';
import MaterialRequestFormSchema from '../validationSchema';
import { getFormUploadFileMetaData } from '../utils/document';
import { getCounterValue } from '../utils/getCounterValue';
import { isCostCenterMatchReceiveType } from '../utils/isCostCenterMatchReceiveType';
import { isValidRequiredFields } from '../utils/isValidRequiredFields';

type handleSubmitType = (
  values: MaterialRequestFormValues,
  formikHelpers: FormikHelpers<MaterialRequestFormValues>
) => void;

const defaultHeaderStepperItems = ['request header', 'materials', 'documents'];
const labels = ['Request Header', 'Materials', 'Documents'];

const MaterialRequisitionCreateForm: React.FC = () => {
  const {
    errorNotification,
    editSuccessNotification,
    saveSuccessNotification,
  } = useContext(NotificationContext);
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(currentUserSelector);
  const requisitionInfo = useAppSelector(materialRequestCreateRequisitionInfo);
  const companies = useAppSelector(getCompaniesDictSelector);
  const costCenterTypes = useAppSelector(getCostCenterTypeDict);
  const currentMaterialCostCenters = useAppSelector(materialCostCenters);
  const currentMaterialStoreOverhead = useAppSelector(materialStoreOverhead);
  const warrantyTypes = useAppSelector(getWarrantyTypeDict);
  const currencies = useAppSelector(getCurrencies);
  const mrForTypes = useAppSelector(getMrForDict);
  const [getCostCenter] = useGetCostCenterMutation();
  const { deleteItem, messageModal, modalType, titleModal, showModal } =
    useAppSelector(modalManagerItem);
  const { step } = useAppSelector(currentMaterialManagest);
  const [disabledSaveForm, setDisableSaveForm] = useState(true);
  const [disabledNextStep, setDisabledNextStep] = useState(true);
  const mrSelectAllManager = useAppSelector(mrSelectAllManagerSelector);
  const mrSearchManager = useAppSelector(mrSearchManagerSelector);

  const [listDocuments, setListDocuments] = useState<
    Array<MaterialRequisitionDocumentResponse>
  >([]);
  const [getRequisitionCodeDescItems] =
    useGetRequisitionCodeDescItemsMutation();
  const [requisitionItems, setRequisitionItems] =
    useState<RequestListSearchResponse<MaterialRequisitionItemFormResponse>>();
  const [listItems, setListItems] =
    useState<MaterialRequisitionItemFormResponse[]>();
  const modalManagerConfig = useAppSelector(modalManager);
  const [formUpload] = useFormUploadMutation();
  const [postRequisitionForm] = usePostRequisitionFormMutation();
  const [getRequisitionItems, resultItems] = useGetRequisitionItemsMutation();
  const [getRequisitionDocuments, resultDocuments] =
    useGetRequisitionDocumentsMutation();
  const isItemsLoaded = useIsLoadedConent(resultItems.isSuccess);
  const isDocumentsLoaded = useIsLoadedConent(resultDocuments.isSuccess);
  const [isRefetchedItems, setIsRefetchedItems] = useState(false);
  const [saveMaterialItem] = usePostRequisitionItemFormMutation();
  const [deleteItemMaterial] = useDeleteRequisitionItemFormMutation();
  const [deleteItemDocument] = useDeleteRequisitionDocumentMutation();
  const { handleBackToListRequests } = useNavigationToListRequests();
  const [saveRequisitionDocument] = usePostRequisitionDocumentMutation();
  const [getStoreOverhead] = useGetStoreOverheadMutation();
  const currentMRequest = useAppSelector(currentMaterialRequest);
  const currentFileUpload = useAppSelector(currentFileUploadSelector);
  const navigate = useNavigate();
  const [dropdownCostCenters, setDropdownCostCenters] = useState<
    Array<CostCenter>
  >([]);

  const onRefetchItems = (requisitionId: number): void => {
    setIsRefetchedItems(true);
    getRequisitionItems({
      requisitionId,
    })
      .unwrap()
      .then((response) => {
        setListItems([]);
        setRequisitionItems(response);
        setIsRefetchedItems(false);
      });
  };

  const onRefetchDocuments = (requisitionId: number): void => {
    setIsRefetchedItems(true);
    getRequisitionDocuments(String(requisitionId))
      .unwrap()
      .then((response) => {
        setListDocuments(response);
        setIsRefetchedItems(false);
      });
  };

  useEffect(() => {
    if (defaultHeaderStepperItems.length - 1 === step) {
      dispatch(materialRequestActions.setShowConfirmButton(true));
    } else {
      dispatch(materialRequestActions.setShowConfirmButton(false));
    }
  }, [step]);

  useEffect(() => {
    if (step === StepType.MATERIALS) {
      onRefetchItems(currentMRequest?.requestId);
    }
  }, [step, currentMRequest?.requestId]);

  useEffect(() => {
    if (requisitionItems?.content?.length && !resultItems.isLoading) {
      getRequisitionCodeDescItems({ reqId: Number(currentMRequest?.requestId) })
        .unwrap()
        .then((descriptionData) => {
          const mappedData = requisitionItems?.content?.map(
            (requisitionItem) => {
              const findDescriptionItem = descriptionData.find(
                (itemDesc) => itemDesc.reqItemId === requisitionItem.reqItemId
              );

              return findDescriptionItem
                ? {
                    ...requisitionItem,
                    actName: findDescriptionItem.data.actName,
                    resDesc: findDescriptionItem.data.resDesc,
                    matDesc: findDescriptionItem.data.matDesc,
                    plantCode: findDescriptionItem.data.plantCode,
                    plantName: findDescriptionItem.data.plantName,
                    ledgerName: findDescriptionItem.data.ledgerName,
                  }
                : requisitionItem;
            }
          );

          setListItems(mappedData);
        });
    }
  }, [requisitionItems, resultItems.isLoading]);

  useEffect(() => {
    if (step === StepType.DOCUMENTS && currentMRequest?.requestId) {
      onRefetchDocuments(currentMRequest.requestId);
    }
  }, [step, currentMRequest]);

  useEffect(() => {
    if (step === StepType.DOCUMENTS) {
      dispatch(materialRequestActions.setShowConfirmButton(true));
      setDisableSaveForm(false);
    } else {
      dispatch(materialRequestActions.setShowConfirmButton(false));
    }
  }, [step]);

  const uploadFile = useCallback(
    (
      reqFileId: string,
      currentFile: FileUpload
    ): Promise<DocumentFormUploadResponse> => {
      const { formData, filepath } = currentFile;

      const body = getFormUploadFileMetaData(reqFileId, filepath);

      return formUpload({
        document: JSON.stringify(body),
        body: formData,
      }).unwrap();
    },
    [currentFileUpload]
  );

  const handleSubmitForm: handleSubmitType = () => {
    setDisableSaveForm(true);
  };

  const formik = useFormik({
    initialValues: initialValuesForm,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
    validationSchema: MaterialRequestFormSchema,
  });

  useEffect(() => {
    if (step === StepType.MATERIALS) {
      setDisabledNextStep(false);
      setDisableSaveForm(false);
    }
  }, [step]);

  useEffect(() => {
    if (
      step === StepType.REQUEST_HEADER &&
      isValidRequiredFields({
        ccId: formik.values.ccId,
        ccTypeId: formik.values.ccTypeId,
        compId: formik.values.compId,
        mrFor: formik.values.mrFor,
        receiveStoreId: formik.values.receiveStoreId,
        warrantyTypeId: formik.values.warrantyTypeId,
      })
    ) {
      setDisabledNextStep(false);
      setDisableSaveForm(false);
    } else if (step === StepType.REQUEST_HEADER) {
      setDisabledNextStep(true);
      setDisableSaveForm(true);
    }
  }, [
    step,
    formik.values.compId,
    formik.values.mrFor,
    formik.values.ccTypeId,
    formik.values.ccId,
    formik.values.receiveStoreId,
    formik.values.warrantyTypeId,
    isNotNullValues,
    isValidRequiredFields,
  ]);

  useEffect(() => {
    if (
      step === StepType.REQUEST_HEADER &&
      isNotNullValues(formik.values.compId, formik.values.ccTypeId)
    ) {
      getCostCenter({
        allocationId: String(formik.values.ccTypeId),
        compId: String(formik.values.compId),
        empNo: currentUser.empNumber,
      })
        .unwrap()
        .then((response) => setDropdownCostCenters(response));
    }
  }, [
    step,
    formik.values.compId,
    currentUser.empNumber,
    formik.values.ccTypeId,
    isNotNullValues,
  ]);

  useEffect(() => {
    if (
      step === StepType.REQUEST_HEADER &&
      isNotNullValues(
        formik.values.compId,
        formik.values.ccTypeId,
        formik.values.ccId
      )
    ) {
      if (
        isCostCenterMatchReceiveType(
          Number(formik.values.ccTypeId),
          Number(formik.values.ccId)
        )
      ) {
        getStoreOverhead({
          ccTypeId: formik.values.ccTypeId!,
          compId: formik.values.compId!,
          ccId: formik.values.ccId!,
        })
          .unwrap()
          .then(
            (response) =>
              response &&
              dispatch(
                materialRequestActions.setMaterialStoreOverhead(response)
              )
          );
      }
    }
  }, [
    step,
    formik.values.compId,
    formik.values.ccId,
    formik.values.ccTypeId,
    isNotNullValues,
    isCostCenterMatchReceiveType,
  ]);

  useEffect(() => {
    const list = Array.isArray(listItems) && listItems?.length;
    if (step === StepType.MATERIALS && list) {
      setDisabledNextStep(false);
      setDisableSaveForm(false);
    }
  }, [step, listItems]);

  const handleSaveAsDraft = useCallback(
    (isNextStep?: boolean, stepPoint?: number): void => {
      if (isNextStep && stepPoint && stepPoint > 0) {
        dispatch(materialRequestActions.setNextStep(1));
        return;
      }

      const body = {
        ...formik.values,
        compId: Number(formik.values.compId),
        ccId: formik.values.ccId,
        statusId: currentMRequest?.reqStatusId,
        purchaseOfficer: null,
      } as MaterialRequisitionFormRequest;

      if (currentMRequest?.requestId) {
        body.requisitionId = currentMRequest?.requestId;
      }

      if (currentMRequest?.requisitionNo) {
        body.reqNo = currentMRequest?.requisitionNo;
      }

      postRequisitionForm(body)
        .unwrap()
        .then(
          ({
            requisitionId,
            reqNo,
            createdOn,
            statusId,
            compId,
            ccTypeId,
            mrFor,
            ccId,
          }) => {
            if (isNextStep) {
              dispatch(
                materialRequestActions.setMaterialRequest({
                  createdDate: createdOn,
                  requestId: requisitionId,
                  requisitionNo: reqNo,
                  reqStatusId: statusId,
                })
              );
              dispatch(
                materialRequestActions.setMaterialHeaderInfo({
                  companyName:
                    findCompanyType(compId, companies)?.compCode || '',
                  compId,
                  costCenterId: ccId,
                  costCenter:
                    findCostCenter(currentMaterialCostCenters, ccId)?.name ||
                    '',
                  costCenterType:
                    findCostCenterType(costCenterTypes, ccTypeId)?.codeDesc ||
                    '',
                  mrFor: findMrForType(mrForTypes, mrFor)?.codeDesc || '',
                  unit: '',
                })
              );

              dispatch(materialRequestActions.setNextStep(1));
            }

            setDisableSaveForm(false);

            const cb = currentMRequest?.requestId
              ? editSuccessNotification
              : saveSuccessNotification;
            cb(String(reqNo));

            if (!isNextStep) {
              dispatch(materialRequestActions.clearForm());
              handleBackToListRequests();
            }
          }
        )
        .catch((message) => {
          errorNotification(message?.data);
        });
    },
    [
      formik.values,
      currentMaterialCostCenters,
      currentMRequest,
      currentUser?.empId,
      currentMRequest?.requisitionNo,
    ]
  );

  const handleSaveDocument = useCallback(
    async (
      formikValues: MaterialRequisitionDocumentRequest,
      requisitionId: number,
      fileUpload: FileUpload,
      addAnotherItem = false
    ) => {
      const filepath = fileUpload?.filepath || formikValues.filePath;
      if (filepath && requisitionId) {
        let documentExternal = null;
        if (fileUpload?.filepath) {
          documentExternal = await uploadFile(
            String(requisitionId),
            fileUpload
          );
        }

        if (documentExternal?.documentId) {
          const {
            docDesc,
            docName,
            isConfidential,
            matId,
            procDocTypeId,
            deleteFlag,
          } = formikValues;

          const body = {
            reqId: requisitionId,
            docDesc,
            docName,
            filePath: filepath,
            isConfidential,
            matId,
            procDocTypeId,
            deleteFlag,
            documentExternalId: documentExternal.documentId,
          } as MaterialRequisitionDocumentRequest;

          saveRequisitionDocument(body)
            .unwrap()
            .then(() => {
              if (!addAnotherItem) {
                dispatch(
                  materialRequestActions.setModalManager({
                    ...modalManagerConfig,
                    open: false,
                  })
                );
              }
              dispatch(materialRequestActions.setModalButtonDisable(true));
              dispatch(fileUploadActions.setFile(null));
              onRefetchDocuments(requisitionId);
            });
        }
      }
    },
    [uploadFile, modalManagerConfig]
  );

  const handleSaveMaterialItem = useCallback(
    (
      formikValues: MaterialRequisitionItemFormResponse,
      requisitionId: number,
      addAnotherItem = false
    ) => {
      const {
        matId,
        matCode,
        ledgerCode,
        plantCode,
        actCode,
        actId,
        resId,
        boqId,
        unitId,
        reqQty,
        issuedQty,
        specification,
        statusId,
        approverNo,
        resCode,
        specId,
        compProjId,
        storeId,
        avlQty,
        rate,
        pettyCashQty,
        transferQty,
        transferRemarks,
        mtvId,
        plantId,
        ledgerId,
        budgetCategoryId,
        conReqId,
        repeatForAll,
        reqItemId,
      } = formikValues;

      const body = {
        reqItemId: reqItemId || null,
        requisitionId,
        matId,
        matCode,
        actId,
        actCode,
        resId,
        boqId,
        unitId,
        reqQty,
        issuedQty,
        specification,
        statusId,
        approverNo,
        resCode,
        specId,
        compProjId,
        storeId,
        avlQty,
        rate,
        pettyCashQty,
        transferQty,
        transferRemarks,
        mtvId,
        plantId,
        plantCode,
        ledgerId,
        ledgerCode,
        budgetCategoryId,
        conReqId,
        repeatForAll,
      } as MaterialRequisitionItemFormRequest;

      saveMaterialItem(body)
        .unwrap()
        .then(() => {
          if (!addAnotherItem) {
            dispatch(
              materialRequestActions.setModalManager({
                ...modalManagerConfig,
                open: false,
              })
            );
          }
          dispatch(materialRequestActions.setModalButtonDisable(true));
          onRefetchItems(requisitionId);
        });
    },
    [saveMaterialItem, onRefetchItems]
  );

  const handleAddMaterial = useCallback((): void => {
    dispatch(
      materialRequestActions.setModalManager({
        isEditMode: false,
        okText: 'Add Material',
        title: 'Add Material',
        open: true,
      })
    );
    dispatch(fileUploadActions.setFile(null));
  }, []);

  const handleAddDocuments = useCallback(() => {
    dispatch(
      materialRequestActions.setModalManager({
        isEditMode: false,
        okText: 'Add Document',
        title: 'Add Document',
        open: true,
      })
    );
  }, []);

  const handleSwitchStep = useCallback(
    (stepNum: number): void => {
      dispatch(materialRequestActions.setSwitchStep(stepNum));
    },
    [dispatch]
  );

  const handleDeleteItemMaterial = useCallback(
    (deleteItems?: Array<string | number>) => {
      deleteItemMaterial(deleteItems || [])
        .unwrap()
        .then(() => {
          dispatch(
            materialRequestActions.setModalManagerItem({
              deleteItem: [],
              messageModal: '',
              modalType: 'Material',
              titleModal: '',
              showModal: false,
            })
          );
          onRefetchItems(currentMRequest?.requestId);
        });
    },
    [currentMRequest?.requestId]
  );

  const handleDeleteItemDocument = useCallback(
    (deleteItems?: Array<MaterialRequisitionDocumentResponse>) => {
      deleteItemDocument({
        body: deleteItems || [],
        requisitionId: currentMRequest.requestId,
      })
        .unwrap()
        .then(() => {
          dispatch(
            materialRequestActions.setModalManagerItem({
              deleteItem: [],
              messageModal: '',
              titleModal: '',
              modalType: 'Document',
              showModal: false,
            })
          );
          onRefetchDocuments(currentMRequest.requestId);
        });
    },
    [currentMRequest.requestId]
  );

  const handleNextStep = useCallback((): void => {
    handleSaveAsDraft(true, step);
    dispatch(materialRequestActions.setMRSearchManagerReset());
    dispatch(materialRequestActions.setMRSelectAllManagerReset());
  }, [handleSaveAsDraft, step]);

  const handleFooterAction = useCallback(
    (action: FooterActions) => {
      if (action === FooterActions.SAVE_AS_DRAFT) {
        handleSaveAsDraft();
      }

      if (action === FooterActions.NEXT) {
        handleNextStep();
      }

      if (action === FooterActions.BACK_TO_REQUESTS) {
        dispatch(materialRequestActions.clearForm());
        handleBackToListRequests();
      }

      if (action === FooterActions.CONFIRM_REQUEST) {
        navigate(
          `/mr/${MRFeatureRoutePath.MANAGE_REQUESTS}/${MRFeatureRoutePath.MANAGE_REQUEST_MATERIAL_REQUEST}/${MRFeatureRoutePath.MANAGE_REQUEST_CONFIRM_REQUEST}`
        );
        dispatch(materialRequestActions.setSwitchStep(0));
        dispatch(materialRequestActions.setShowConfirmButton(false));
      }
    },
    [handleBackToListRequests, handleSaveAsDraft, handleNextStep]
  );

  const headerStepperConfig = {
    items: defaultHeaderStepperItems,
    counter: step,
    onClick: handleSwitchStep,
  };

  const handleShowSearch = useCallback(() => {
    dispatch(materialRequestActions.setMRShowSearch(true));
  }, []);

  const handleSearchMaterialItems = useCallback(
    (value: string) => {
      if (listItems) {
        const result = findMaterialItemBySearchValue(listItems, value);
        dispatch(materialRequestActions.setMRSearchedItems(result));
      }
    },
    [listItems]
  );

  const handleSearchDocumentItems = useCallback(
    (value: string) => {
      const result = findDocumentItemBySearchValue(listDocuments, value);
      dispatch(materialRequestActions.setMRSearchedItems(result));
    },
    [listDocuments]
  );

  const handleCloseSearch = useCallback(() => {
    dispatch(materialRequestActions.setMRShowSearch(false));
    dispatch(materialRequestActions.setMRSearchedItems([]));
  }, []);

  const handleSelectAllItems = useCallback(() => {
    if (listItems) {
      const idItems = listItems?.map((item) => item.reqItemId);
      dispatch(materialRequestActions.setMRSelectAllItems(true));
      dispatch(materialRequestActions.setMRSelectAddItems(idItems));
    }
  }, [listItems]);

  const handleSelectAllDocuments = useCallback(() => {
    if (listDocuments.length) {
      dispatch(materialRequestActions.setMRSelectAllItems(true));
      dispatch(materialRequestActions.setMRSelectAddItems(listDocuments));
    }
  }, [listDocuments]);

  const handleUnselectAllItems = (): void => {
    dispatch(materialRequestActions.setMRSelectAllItems(false));
    dispatch(materialRequestActions.setMRSelectAddItems([]));
  };

  const handleDeleteAllMaterialsSelectedItems = useCallback(() => {
    const { selectedItems } = mrSelectAllManager;

    try {
      handleDeleteItemMaterial(selectedItems as Array<string | number>);
      handleUnselectAllItems();
    } catch (error) {
      errorNotification(error as string);
    }
  }, [mrSelectAllManager]);

  const handleDeleteAllDocumentsSelectedItems = useCallback(() => {
    const { selectedItems } = mrSelectAllManager;

    try {
      handleDeleteItemDocument(
        selectedItems as Array<MaterialRequisitionDocumentResponse>
      );
      handleUnselectAllItems();
    } catch (error) {
      errorNotification(error as string);
    }
  }, [mrSelectAllManager]);

  const renderMaterialActionsHeader = useCallback(() => {
    const { isSelected, selectedItems } = mrSelectAllManager;
    const { isSearch } = mrSearchManager;

    if (step === StepType.MATERIALS) {
      const counterValue = getCounterValue(
        isSelected,
        selectedItems,
        requisitionItems
      );
      return (
        <MaterialActions
          label={labels[StepType.MATERIALS]}
          handleAddMaterial={handleAddMaterial}
          handleSelectAllItems={handleSelectAllItems}
          handleUnselectAllItems={handleUnselectAllItems}
          handleDeleteAllSelectedItems={handleDeleteAllMaterialsSelectedItems}
          handleShowSearch={handleShowSearch}
          handleCloseSearch={handleCloseSearch}
          handleSearchItems={handleSearchMaterialItems}
          isSelected={isSelected}
          isSearch={isSearch}
          addedItemsCounter={counterValue}
        />
      );
    }
    if (step === StepType.DOCUMENTS) {
      const counterValue = getCounterValue(
        isSelected,
        selectedItems,
        listDocuments
      );
      return (
        <MaterialActions
          label={labels[StepType.DOCUMENTS]}
          handleAddMaterial={handleAddDocuments}
          handleSelectAllItems={handleSelectAllDocuments}
          handleUnselectAllItems={handleUnselectAllItems}
          handleDeleteAllSelectedItems={handleDeleteAllDocumentsSelectedItems}
          handleShowSearch={handleShowSearch}
          handleCloseSearch={handleCloseSearch}
          handleSearchItems={handleSearchDocumentItems}
          isSelected={isSelected}
          isSearch={isSearch}
          addedItemsCounter={counterValue}
        />
      );
    }
    return null;
  }, [step, listItems, listDocuments, mrSelectAllManager, mrSearchManager]);

  const handleDeleteModalSuccess = useCallback(() => {
    if (modalType === 'Material') {
      handleDeleteItemMaterial(deleteItem as Array<number>);
    }

    if (modalType === 'Document') {
      handleDeleteItemDocument(
        deleteItem as MaterialRequisitionDocumentResponse[]
      );
    }
  }, [
    modalType,
    deleteItem,
    handleDeleteItemMaterial,
    handleDeleteItemDocument,
  ]);

  const handleCloseNotificationModal = (): void => {
    dispatch(
      materialRequestActions.setModalManagerItem({
        deleteItem: [],
        messageModal: '',
        modalType: 'Material',
        titleModal: '',
        showModal: false,
      })
    );
  };

  return (
    <Flex gap={10} vertical>
      <MainForm
        handleSubmit={formik.handleSubmit}
        disabledSaveForm={disabledSaveForm}
        disabledNextStep={disabledNextStep}
        onFooterAction={handleFooterAction}
        userInfo={currentUser}
        showMRsection
        requisitionInfo={requisitionInfo}
        formType="mr"
        headerStepperOptions={headerStepperConfig}
        requestHeaderStep={step === StepType.REQUEST_HEADER}
      >
        <FormItems actions={renderMaterialActionsHeader()}>
          <MaterialFormChanger label={labels[step]} step={step}>
            <RequestHeaderSection
              formik={formik}
              companies={transformCompaniesDictToOptions(companies)}
              costCenters={transformCostCenterDictToOptions(
                dropdownCostCenters
              )}
              storeOverheadOptions={transformStoreOverheadToOption(
                currentMaterialStoreOverhead
              )}
              costCenterTypes={transformDictToOptions(costCenterTypes)}
              mrForTypes={transformDictToOptions(mrForTypes)}
              warrantyTypes={transformDictToOptions(warrantyTypes)}
              currencies={transformCurrenciesToOptions(currencies)}
            />
            {isItemsLoaded && !isRefetchedItems ? (
              <MaterialsSection
                listItems={
                  mrSearchManager.searchedItems.length
                    ? (mrSearchManager.searchedItems as MaterialRequisitionItemFormResponse[])
                    : listItems || []
                }
                handleSaveMaterialItem={handleSaveMaterialItem}
              />
            ) : (
              <div>
                <MSkeleton repeat={3} className="skeleton-item" />
              </div>
            )}

            {isDocumentsLoaded && !isRefetchedItems ? (
              <DocumentsSection
                currentUser={currentUser}
                handleSaveDocument={handleSaveDocument}
                listItems={
                  mrSearchManager.searchedItems.length
                    ? (mrSearchManager.searchedItems as MaterialRequisitionDocumentResponse[])
                    : listDocuments || []
                }
              />
            ) : (
              <div>
                <MSkeleton repeat={3} className="skeleton-item" />
              </div>
            )}
          </MaterialFormChanger>
        </FormItems>
      </MainForm>
      <RequiredNotification
        title={titleModal}
        message={messageModal}
        isModalOpen={showModal}
        textSuccessBtn="Yes, Delete"
        textCancelBtn="No, Thanks"
        handleCancel={handleCloseNotificationModal}
        handleSuccess={handleDeleteModalSuccess}
        isDeleteNotification
      />
    </Flex>
  );
};

export default MaterialRequisitionCreateForm;
